<template>
  <div class="switch-checkbox">
    <label :class="disabled === false ? 'switch-checkbox__label' : 'switch-checkbox__label switch-checkbox__label--disabled'">
      <input type="checkbox" class="switch-checkbox__input" v-model="isChecked" :disabled="disabled"/>
      <div :class="['switch-checkbox__custom', {'switch-checkbox__custom--checked': isChecked}]" />
      {{text}}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onChange: Function,
  },

  watch: {
    isChecked() {
      this.onChange(this.isChecked);
    },
    checked() {
      this.isChecked = this.checked;
    },
  },

  data() {
    return {
      isChecked: this.checked,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.switch-checkbox {
  &__input {
    display: none;
  }

  &__label {
    font-size: 18px;
    color: #000;
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    &--disabled {
      color: var(--grey-eight);
    }
  }

  &__custom {
    $width: 40px;
    $height: 20px;
    $circleWidth: $width / 2;
    $circleHeight: $height;
    $sliderHeight: $height / 1.3;

    width: $width;
    min-width: $width;
    height: $height;
    margin-right: 10px;
    position: relative;
    z-index: 0;

    &:before {
      content: "";
      display: block;
      width: 100%;
      height: $sliderHeight;
      background-color: #9e9e9e;
      opacity: 0.5;
      border-radius: $sliderHeight;
      position: absolute;
      z-index: 1;
      top: 50%;
      transform: translateY(-50%);
    }

    &:after {
      content: "";
      display: block;
      width: $circleWidth;
      height: $circleHeight;
      background-color: #fff;
      border-radius: 50%;
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
      position: absolute;
      z-index: 2;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      transition: 0.2s transform, 0.2s color;
    }

    &--checked {
      &:before {
        background-color: #e94f0a;
      }

      &:after {
        background-color: #e94f0a;
        transform: translateY(-50%) translateX($width - $circleWidth);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SwitchCheckbox.vue